
export const REQUEST_COMPLETE = (METHOD, TYPE) =>
    `COMMON/REQUEST/${METHOD}_${TYPE}_REQUEST_COMPLETE`;
export const REQUEST_FAILURE = (METHOD, TYPE) =>
    `COMMON/REQUEST/${METHOD}_${TYPE}_REQUEST_FAILURE`;
export const REQUEST_START = (METHOD, TYPE) =>
    `COMMON/REQUEST/${METHOD}_${TYPE}_REQUEST_START`;

export default function request(state = {}, action) {
    switch (action.type) {
    case REQUEST_COMPLETE: {
        return requestCompleteReducer(state);
    }
    case REQUEST_FAILURE: {
        return requestFailureReducer(state, action);
    }
    case REQUEST_START: {
        return requestStartReducer(state);
    }
    default: {
        return state;
    }
    }
}

function requestCompleteReducer(state) {
    return {
        ...state,
        inProgress: false
    };
}

function requestFailureReducer(state, action) {
    const { error, method, type } = action.payload;
    const errorObj = {
        ...error,
        meta: {
            method,
            type
        }
    };
    return {
        ...state,
        errors: [
            ...state.errors,
            errorObj
        ],
        inProgress: false
    };
}

function requestStartReducer(state) {
    return {
        ...state,
        inProgress: true
    };
}

export const requestComplete = (METHOD, TYPE) => ({
    type: REQUEST_COMPLETE(METHOD, TYPE)
});

export const requestFailure = (METHOD, TYPE, error) => ({
    type: REQUEST_FAILURE(METHOD, TYPE),
    payload: {
        error,
        METHOD,
        TYPE
    }
});

export const requestStart = (METHOD, TYPE) => ({
    type: REQUEST_START(METHOD, TYPE)
});



// WEBPACK FOOTER //
// ./src/modules/request/index.js